import type { TDadataFullAddressSelectOption } from 'shared/types/TDaData';

export const validationDadata = (address: string, dadataAddresses?: TDadataFullAddressSelectOption[]) => {
  const selectedDadataAddress = dadataAddresses?.find((dadataAddress) => dadataAddress.value === address);

  if (!address) {
    return { _errorMessage: 'Укажите адрес' };
  }

  if (!selectedDadataAddress) {
    return { _errorMessage: 'Не удалось распознать адрес, введите его заново' };
  }

  if (!selectedDadataAddress.data.house) {
    return { _errorMessage: 'Укажите полный адрес' };
  }

  return { selectedDadataAddress };
};
